import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { AlertModalComponent } from '../alert-modal/alert-modal.component';

/**
 * Shared confirmation for permanently unlinking a vehicle from a customer profile.
 */
@Component({
  selector: 'app-delete-vehicle-alert-modal',
  standalone: true,
  imports: [AlertModalComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <app-alert-modal
      [isOpen]="isOpen"
      title="Delete Vehicle?"
      description="Are you sure you want to remove this vehicle from the customer's profile? It will no longer appear in their list or be available for future bookings. You can add it again later if needed."
      primaryButtonText="Yes, Delete Vehicle"
      secondaryButtonText="Cancel"
      primaryButtonClass="btn-danger"
      secondaryButtonClass="btn-secondary"
      [showWarning]="true"
      warningMessage="Note: This action is permanent. The vehicle will be unlinked from all past records."
      (close)="cancel.emit()"
      (primaryAction)="confirm.emit()"
      (secondaryAction)="cancel.emit()"
    >
    </app-alert-modal>
  `,
})
export class DeleteVehicleAlertModalComponent {
  @Input() isOpen = false;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}
